﻿import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useQueryClient } from "react-query";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { ReactComponent as ArrowUpSvg } from "@/assets/images/desktop/Flechaverdehorizontal.svg";
import { ReactComponent as ArrowDownSvg } from "@/assets/images/desktop/flechaverdeabajo.svg";

import { formatMilesDecimalNew, hasPermission } from "@/services/Utils";
import IrrigationTableBodyDetail from "./IrrigationTableBodyDetail";

import classes from "../../maintainers.module.scss";

const IrrigationsTableBody = ({ data, handleDelete, permissions, base }) => {
	const navigate = useNavigate();

	const queryClient = useQueryClient();

	const { search, estate_id } = useSelector((state) => state.auth.filter);

	const toggleShowDetail = (id) => {
		const newIrrigations = data.map((item) => {
			if (item.id === id) {
				item.active = !item.active;
			}
			return item;
		});

		queryClient.setQueryData(["irrigations", { ...base, search, estate_id }], (oldData) => {
			return {
				...oldData,
				irrigations: {
					...(oldData?.irrigations ?? {}),
					data: newIrrigations,
				},
			};
		});
	};

	return (
		<tbody>
			{data &&
				data.map((item, i) => {
					return [
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.column}`}>
									{item.estates_parents && item.estates_parents.length > 0 ? (
										item.estates_parents.map((estate_parent, k) => <span key={k}>{estate_parent.name}</span>)
									) : (
										<span></span>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.center} ${classes.column}`}>
									{item.estates && item.estates.length > 0 ? (
										item.estates.map((estate, k) => <span key={k}>{estate.name}</span>)
									) : (
										<span></span>
									)}
								</div>
							</td>
							<td className={`${classes.table_td}`} style={{ textAlign: "center" }}>
								<div className={`${classes.table_div}`} style={{ justifyContent: "end" }}>
									{formatMilesDecimalNew(item.total_ha)}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/riegos/editar/" + item.id)} />
									)}
									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{item.active ? (
										<ArrowDownSvg className={classes.icon} onClick={() => toggleShowDetail(item.id)} />
									) : (
										<ArrowUpSvg className={classes.icon} onClick={() => toggleShowDetail(item.id)} />
									)}
								</div>
							</td>
						</tr>,
						<IrrigationTableBodyDetail key={`detail_${i}`} item={item} />,
					];
				})}
		</tbody>
	);
};

export default IrrigationsTableBody;
